import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "../features/login/loginSlice";
import companyTokenReducer from "../features/login/companyTokenSlice";
// import simActivationReducer from "../features/simActivation/simActivationSliceList";
// import simActionReducer from "../features/simActivation/simActionSlice";
import whiteListDeviceReducer from '../features/dashboard/whiteListDeviceSlice';
import dragDropReducer from '../features/drivers/ETSTrips/dragDropSlice';
// import kycReducer from "../features/kycMaster/kycMasterSlice"; // Ensure path is correct

const rootReducer = combineReducers({
  auth: authReducer,
  companyToken: companyTokenReducer,
  // simActivation: simActivationReducer,
  // actionList: simActionReducer,
  whiteListDevice: whiteListDeviceReducer,
  dragDrop: dragDropReducer,
  // kyc: kycReducer, // Updated to use kycReducer
});

export default rootReducer;
